var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "card-inner" },
    [
      _vm.showCheckbox
        ? [
            _vm.data.ManpowerDemandStatus === "New" ||
            _vm.data.ManpowerDemandStatus === "Pending"
              ? _c(
                  "div",
                  {
                    staticClass: "check-wrap",
                    on: {
                      click: function ($event) {
                        return _vm.$refs.check.click()
                      },
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.data.isChecked,
                          expression: "data.isChecked",
                        },
                      ],
                      ref: "check",
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: _vm.data.isChecked,
                        checked: Array.isArray(_vm.data.isChecked)
                          ? _vm._i(_vm.data.isChecked, null) > -1
                          : _vm.data.isChecked,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.clickCheck(_vm.data)
                        },
                        change: function ($event) {
                          var $$a = _vm.data.isChecked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.data,
                                  "isChecked",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.data,
                                  "isChecked",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.data, "isChecked", $$c)
                          }
                        },
                      },
                    }),
                    _vm._m(0),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "detail-header",
          style: { "background-color": _vm.headerBackgroundColor },
        },
        [
          _c("div", { staticClass: "text-wrap" }, [
            _c("span", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.data.ManpowerDemandName)),
            ]),
            _c("span", { staticClass: "number" }, [
              _vm._v(_vm._s(_vm.data.No)),
            ]),
            _c("span", { staticClass: "status" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$common.manpowerDemandStatusFormatter(
                      _vm.data.ManpowerDemandStatus
                    )
                  ) +
                  " "
              ),
            ]),
          ]),
        ]
      ),
      _c("div", { staticClass: "detail-info" }, [
        _c("ul", [
          _c(
            "li",
            [
              _c("eva-icon", { attrs: { name: "person-outline" } }),
              _c("span", [_vm._v(_vm._s(_vm.data.Applicant))]),
            ],
            1
          ),
          _c(
            "li",
            [
              _c("eva-icon", { attrs: { name: "monitor-outline" } }),
              _c("span", [_vm._v(_vm._s(_vm.data.DemandDepartment))]),
            ],
            1
          ),
          _c(
            "li",
            [
              _c("eva-icon", { attrs: { name: "pricetags-outline" } }),
              _c("span", [_vm._v(_vm._s(_vm.data.PositionName))]),
            ],
            1
          ),
          _c(
            "li",
            [
              _c("eva-icon", { attrs: { name: "eye-outline" } }),
              _c("span", [_vm._v(_vm._s(_vm.data.DemandNumber) + " 人")]),
            ],
            1
          ),
          _c(
            "li",
            [
              _c("eva-icon", { attrs: { name: "clock-outline" } }),
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(_vm.$common.dateFormatter(_vm.data.ApplicantTime)) +
                    " ~ " +
                    _vm._s(
                      _vm.$common.dateFormatter(_vm.data.RecruitmentDeadline)
                    )
                ),
              ]),
            ],
            1
          ),
          _vm.category === "apply" || _vm.category === "search"
            ? _c(
                "li",
                [
                  _c("eva-icon", { attrs: { name: "edit-outline" } }),
                  _c("span", [_vm._v(_vm._s(_vm.data.Approver))]),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "button-group" },
        [
          [
            _c(
              "button",
              {
                staticClass: "btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.viewDemand(_vm.data.No)
                  },
                },
              },
              [_vm._v(" 檢視 ")]
            ),
          ],
          _vm._t("apply", null, { props: _vm.data }),
          _vm._t("search", null, { props: _vm.data }),
          _vm._t("review", null, { props: _vm.data }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [_c("i", { staticClass: "fas fa-check" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }